module.exports = __webpack_public_path__ + "static/media/STPLong1w522@2x.b148e9d5.jpg";